import React from "react";
import style from "./Style.module.css";
import org from "../../asset/org.jpg";
import { withAlert } from "react-alert";
import { withRouter } from "react-router-dom";
//import './style.css';
const monthName = [
  "มกราคม",
  "กุมภาพันธ์",
  "มีนาคม",
  "เมษายน",
  "พฤษภาคม",
  "มิถุนายน",
  "กรกฎาคม",
  "สิงหาคม",
  "กันยายน",
  "ตุลาคม",
  "พฤศจิกายน",
  "ธันวาคม",
];
class EditSheet extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      out: [],
      month: parseInt(props.location.search.substring(1).split("&")[0]),
      year: parseInt(props.location.search.substring(1).split("&")[1]),
    };
  }

  async componentDidMount() {}

  render() {
    return (
      <div className={style.page}>
        <div className={style.inner}>
          <img className={style.logo} alt="" src={org} />
          <div className={style.header}>
            รายจ่าย บริษัท มอร์ เซอร์วิสเซส จำกัด
          </div>
          <div className={style.header2}>
            1788 อาคารสิงห์คอมเพล็กซ์ ชั้นที่ 30 ยูนิต 3001-3003,3009-3014
            ถนนเพชรบุรีตัดใหม่ แขวงบางกะปิ เขตห้วยขวาง กรุงเทพมหานคร
          </div>
          <div className={style.header3}>
            โทร. 0972983260 เลขประจำตัวผู้เสียภาษี 0125566010007
          </div>
          <div className={style.local1}>
            เลขที่ M-{this.state.month}-{this.state.year}
          </div>
          <div className={style.local1}>
            ประจำเดือน {monthName[this.state.month - 1]} พ.ศ.
            {this.state.year + 543}
          </div>
          <table className={style.table}>
            <thead>
              <tr>
                <th>ลำดับ</th>
                <th>รายการ</th>
                <th>จำนวนเงิน (บาท)</th>
              </tr>
            </thead>
            <tbody>{this.renderTab()}</tbody>
          </table>
          <div className={style.header4}>
            รวม {this.renderTotal().toFixed(2)} บาท
          </div>
        </div>
      </div>
    );
  }

  renderTab = () => {
    return this.state.out.map((data, i) => {
      return (
        <tr key={i}>
          <td>{i + 1}</td>
          <td>{data.name}</td>
          <td>{data.total}</td>
        </tr>
      );
    });
  };

  renderTotal = () => {
    var sum = 0;
    this.state.out.map((data) => {
      sum += parseFloat(data.total);
      return 0;
    });
    return sum;
  };
}

export default withRouter(withAlert()(EditSheet));
